<template>
  <v-card flat>
    <v-card-text>
      <div class="my-4 subtitle-2">
        Credenciais da API
      </div>
      <div>
        Use a nossa API para programar com os dados da sua
        organização. O Token é necessário para o acesso da API de
        forma segura.
      </div>
      <v-col cols="10">
        <v-text-field
          ref="textToCopy"
          v-model="token"
          label="Token da API"
          dense
          outlined
          readonly
          :loading="loading"
        >
          <template v-slot:append-outer>
            <v-icon @click="copyToText" title="Copiar" class="mr-3">mdi-content-copy</v-icon>
            <v-icon @click="generateNewToken" title="Gerar novo Token" class="icon-primary">mdi-refresh</v-icon>
          </template>
        </v-text-field>
      </v-col>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapActions, mapState } from "vuex";
import EmailConfigurationComponent from "@/components/emailConfig/EmailConfigurationComponent";
export default {
  data() {
    return {
      loading: true,
    };
  },
  async mounted() {
    await this.getToken();
  },
  computed: {
    ...mapState("tokenApiConfiguration", ["token"])
  },
  methods: {
    ...mapActions("tokenApiConfiguration", ["loadToken", "newToken"]),

    async getToken() {
      this.loading = true;
      await this.loadToken().catch(error => {
        this.$swal("Oops...", error.message, "error");
      });
      this.loading = false;
    },
    async generateNewToken() {
      await this.$swal({
        icon: "warning",
        title: `Tem certeza que deseja gerar um novo Token?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Sim!"
      }).then(async result => {
        if (result.value) {
          await this.newToken().catch(error => {
            this.$swal("Oops...", error.message, "error");
          });

          await this.getToken();
        }
      });
    },
    copyToText() {
      const textToCopy = this.$refs.textToCopy.$el.querySelector("input");
      textToCopy.select();
      document.execCommand("copy");
    },
  }
};
</script>
